import { Share2, Mail, Link2 } from "lucide-react";
import { toast } from "sonner";
import { fmtDate } from "@/lib/utils";

export function shareUrl(trip) {
  return `${window.location.origin}/aktuelle-beiladungen?trip=${trip.id}`;
}

export function ShareRoute({ trip }) {
  if (trip.status !== "aktiv") return null;
  const url = shareUrl(trip);
  const text = `Freier Laderaum: ${trip.start_ort} → ${trip.ziel_ort} am ${fmtDate(trip.abfahrt)} – ${trip.freie_m3} m³ frei. Jetzt Beiladung sichern: ${url}`;
  const copy = async () => { try { await navigator.clipboard.writeText(url); toast.success("Link kopiert"); } catch { toast.error("Kopieren nicht möglich"); } };
  return (
    <>
      <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" className="eb-btn-ghost !px-2.5 !py-2 text-emerald-400" title="Per WhatsApp teilen" data-testid={`route-share-wa-${trip.id}`}><Share2 className="w-4 h-4" /></a>
      <a href={`mailto:?subject=${encodeURIComponent(`Beiladung ${trip.start_ort} → ${trip.ziel_ort}`)}&body=${encodeURIComponent(text)}`} className="eb-btn-ghost !px-2.5 !py-2" title="Per E-Mail teilen" data-testid={`route-share-mail-${trip.id}`}><Mail className="w-4 h-4" /></a>
      <button onClick={copy} className="eb-btn-ghost !px-2.5 !py-2" title="Link kopieren" data-testid={`route-share-copy-${trip.id}`}><Link2 className="w-4 h-4" /></button>
    </>
  );
}
